export const BRAND = {
  name: "Empulse Media Agency",
  short: "Empulse",
  tagline: "Bold creative. Data‑sharp marketing.",
  phone: "+60 13-747 7940",
  phoneRaw: "60137477940",
  email: "parvin@empulsemedia.com",
  whatsappMessage: "Hi Empulse! I'd like to know more about your services.",
  locations: [
    {
      city: "Penang",
      coverage: "Serving George Town, Bayan Lepas, Butterworth & surrounding areas",
      hours: "Mon–Fri · 9:30am – 6:30pm",
    },
    {
      city: "Kuala Lumpur",
      coverage: "Serving KL, Petaling Jaya, Subang, Shah Alam & Klang Valley",
      hours: "Mon–Fri · 9:30am – 7:00pm",
    },
    {
      city: "Johor",
      coverage: "Serving Johor Bahru, Iskandar Puteri, Skudai & surrounding areas",
      hours: "Mon–Fri · 9:30am – 6:30pm",
    },
  ],
};

export const SERVICES = [
  {
    id: "video-editing",
    title: "Video Editing",
    short: "Scroll‑stopping cuts",
    description:
      "Short‑form reels, long‑form features, colour grading, motion graphics and sound design.",
    icon: "Film",
    tag: "01",
  },
  {
    id: "videography",
    title: "Videography",
    short: "Cinematic production",
    description:
      "On‑set crews, cinema cameras, lighting, and directors for brand films & campaigns.",
    icon: "Video",
    tag: "02",
  },
  {
    id: "photo-editing",
    title: "Photo Editing",
    short: "Retouch perfection",
    description:
      "High‑end retouching, colour correction, composite work and product clean‑ups.",
    icon: "Wand2",
    tag: "03",
  },
  {
    id: "photography",
    title: "Photography",
    short: "Studio & location",
    description:
      "Product, lifestyle, fashion and corporate shoots — studios across KL, Penang & JB.",
    icon: "Camera",
    tag: "04",
  },
  {
    id: "social-media",
    title: "Social Media Marketing",
    short: "Always‑on growth",
    description:
      "Strategy, content calendars, community, paid social — TikTok, IG, FB, LinkedIn.",
    icon: "Hash",
    tag: "05",
  },
  {
    id: "copywriting",
    title: "Copywriting",
    short: "Words that convert",
    description:
      "Brand voice, ad copy, scripts, website copy, email sequences — in English & BM.",
    icon: "PenTool",
    tag: "06",
  },
  {
    id: "content-creation",
    title: "Content Creation",
    short: "Ideas, on a schedule",
    description:
      "Talent, UGC creators, concepting, shot‑lists and full end‑to‑end production.",
    icon: "Sparkles",
    tag: "07",
  },
  {
    id: "graphic-design",
    title: "Graphic Design",
    short: "Identity systems",
    description:
      "Branding, packaging, social kits, editorial layouts & print collateral.",
    icon: "Palette",
    tag: "08",
  },
  {
    id: "seo",
    title: "SEO",
    short: "Found first. Always.",
    description:
      "Technical audits, content strategy, on‑page optimisation and local SEO for Malaysia.",
    icon: "Search",
    tag: "09",
  },
];

export const PACKAGES = [
  {
    id: "spark",
    name: "Spark",
    priceMYR: 2500,
    cadence: "/ month",
    blurb: "For small businesses finding their rhythm online.",
    features: [
      "8 social media posts / month",
      "1 reel or short‑form video",
      "Basic copywriting & captions",
      "Monthly performance report",
      "1 location (Penang / KL / Johor)",
    ],
    cta: "Start with Spark",
    highlighted: false,
  },
  {
    id: "pulse",
    name: "Pulse",
    priceMYR: 4000,
    cadence: "/ month",
    blurb: "Momentum for growing brands with content hunger.",
    features: [
      "16 social posts + 4 reels / month",
      "Half‑day photo + video shoot",
      "Social ads management (up to RM300 spend)",
      "On‑page SEO & monthly blog article",
      "Dedicated strategist & bi‑weekly calls",
    ],
    cta: "Get the Pulse plan",
    highlighted: true,
  },
  {
    id: "amplify",
    name: "Amplify",
    priceMYR: 5000,
    cadence: "/ month",
    blurb: "Full‑funnel, multi‑channel firepower.",
    features: [
      "Unlimited revisions content calendar",
      "Full‑day shoot + premium edit",
      "Performance ads (up to RM500 spend)",
      "Advanced SEO + landing pages",
      "Brand & creative direction included",
    ],
    cta: "Let's Amplify",
    highlighted: false,
  },
];

export const TIME_SLOTS = [
  "10:00 AM",
  "11:00 AM",
  "12:00 PM",
  "02:00 PM",
  "03:00 PM",
  "04:00 PM",
  "05:00 PM",
];
